const OrchidKottayam=[{
      src: 'https://i.postimg.cc/pTrtHP0B/Copy-of-Lobby-2-1.jpg',
      alt: 'Orchid Kottayam Lobby',
    },
    {
      src: 'https://i.postimg.cc/h4HhpYjY/Copy-of-Suite-10-2.jpg',
    alt: 'Orchid Kottayam Suite room',
    },
    {
      src: 'https://i.postimg.cc/3RkJZjH7/Suite-5-1.jpg',
 alt: 'Orchid Kottayam Suite Room',    },
    {
      src: 'https://i.postimg.cc/nLzHHKr7/Suite-Sitting-3.jpg',
 alt: 'Orchid Kottayam Suite Sitting ',    },
    {
      src: 'https://i.postimg.cc/TP4Thy5s/Facade-Night-2.jpg',
 alt: 'Orchid Kottayam Facade',    }, {
      src: 'https://i.postimg.cc/6pFH3t50/Premium-12-1.jpg',
   alt: 'Orchid Kottayam Premium Room ',
    }, {
      src: 'https://i.postimg.cc/cJYFt2vN/Lobby-1.jpg',
    alt: 'Orchid Kottayam Lobby ',
    }, {
      src: 'https://i.postimg.cc/50VnBgzQ/Reception-1.jpg',
      alt: 'Orchid Kottayam Reception',
    }, {
      src: 'https://i.postimg.cc/x8j57dt0/Restaurant-1.jpg',
 alt: 'Orchid Kottayam Restaurant',
    },{
      src: 'https://i.postimg.cc/XNxQ5wYX/Super-deluxe-17.jpg',
      alt: 'Orchid Kottayam Super Delux Room',
    },{
      src: 'https://i.postimg.cc/7Zz3K7w3/Super-Deluxe-20-1.jpg',
 alt: 'Orchid Kottayam Super Delux Room',
    },
    {
      src: 'https://i.postimg.cc/yxFJFhFx/Sopanam-Sitting-2.jpg',
 alt: 'Orchid Kottayam Sopanam',
    },]

    export default OrchidKottayam;